import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';

import _ from 'lodash';

import './faq.less';
import {connect} from "react-redux";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import {getFaq} from "store/reducers/faq";

@connect((state) => ({}), {getFaq})

export default class FaqComponent extends Component {

    state = {
        items: [],
        loading: false,
    };

    async componentDidMount() {
        this.setState({loading: true});
        const response = await this.props.getFaq({
            filters: {
                onlyActive: true,
            },
            pagination: {
                page: 1,
            },
            order: {
                column: 'question',
                direction: 'asc',
            },
        });
        this.setState({loading: false});
        if (response.isOk) {
            const items = response.payload.items;
            this.setState({items});
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <Page pageId="Faq" title="Наиболее частые вопросы">
                {loader}
                <div className="full">
                    {this.state.items.map(::this.renderItem)}
                </div>
            </Page>
        );
    }

    renderItem(item, index) {
        return (
            <div key={index} className="faq-block">
                <strong className="question">
                    Вопрос: {item.question}
                </strong>
                <div className="answer">
                    Ответ: {item.answer}
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/modules/faq/faq.js